import Super from './column.gjs';

export default class SpdsLayoutFlexReverseColumn extends Super {
  reverse = true;
  variantClass = 'spds-layout-flex-reverse-column';
}
